import React from 'react'
import '../../../styles/Professeurs.css'

function Professeurs() {
  return (
    <div id="Professeurs" className="professeurs">
      <div id="section-professeurs1" className="sectionProfs">
        <div id="texte-profs" className="containerTexteProfs">
          <div id="text_Profs-titre" className="textTitre">
            AUDREY BOURGEOIS
          </div>
          <div id="text_Profs-1" className="blockTextProfs">
            <p className="blockTextProfsP">
              De l'expérience, de la pédagogie et une bonne humeur à toute
              épreuve.
            </p>
            <p className="blockTextProfsP">
              - 3e place du Championnat de France en danses standards, Bordeaux,
              1995
              <br />
              - Championne d'Ile de France en danses standards, 1999
              <br />
              - Vice-championne d'Ile de France en danses latines, 1999
              <br />
              - Championne de France à Valence, 2000
              <br />
              - Compagnie du Feeling Dance, Paris (chorégraphe Charly Moser),
              2000-2006
              <br />
              - Monitorat et Professorat, 2004
              <br />
              - Professeur au Feeling Dance Studio (Paris), 2004-2006
              <br />
              - Professeur dans l'association Jet7 Swing (Pessac), 2007-2016
              <br />- Professeur dans l'association DUO DANSE (Blanquefort)
              depuis 2016
            </p>
          </div>
          <div id="text_Profs-2" className="blockTextProfs">
            <blockquote className="blockquote">
              <p className="blockquoteP">
                Elle saura à coup sûr vous faire aimer la danse.
              </p>
            </blockquote>
          </div>
        </div>
        <div id="image" className="containerImageProfs">
          <figure id="img_bloc" className="blocImageProfs">
            <img
              src="./images/audrey_web.jpg"
              data-src="./images/audrey_web.jpg"
              alt="Cours de danse Blanquefort"
              width="1276"
              height="687"
              className="image"
              onMouseOver={(e) => e.currentTarget.classList.add('imageHover')}
              onMouseOut={(e) => e.currentTarget.classList.remove('imageHover')}
            />
          </figure>
        </div>
      </div>
      {/* <div id="section-professeurs2" className="sectionProfs">
        <div id="texte-profs" className="containerTexteProfs">
          <div id="text_Profs-titre" className="textTitre">
            ORIANE
          </div>
          <div id="text_Profs-1" className="blockTextProfs">
            <p className="blockTextProfsP">
              De l'expérience, de la pédagogie et une bonne humeur à toute
              épreuve.
            </p>
            <p className="blockTextProfsP">
              - 3e place du Championnat de France en danses standards, Bordeaux,
              1995
              <br />
              - Championne d'Ile de France en danses standards, 1999
              <br />
              - Vice-championne d'Ile de France en danses latines, 1999
              <br />
              - Championne de France à Valence, 2000
              <br />
              - Compagnie du Feeling Dance, Paris (chorégraphe Charly Moser),
              2000-2006
              <br />
              - Monitorat et Professorat, 2004
              <br />
              - Professeur au Feeling Dance Studio (Paris), 2004-2006
              <br />
              - Professeur dans l'association Jet7 Swing (Pessac), 2007-2016
              <br />- Professeur dans l'association DUO DANSE (Blanquefort)
              depuis 2016
            </p>
          </div>
          <div id="text_Profs-2" className="blockTextProfs">
            <blockquote className="blockquote">
              <p className="blockquoteP">
                Elle saura à coup sûr vous faire aimer la danse.
              </p>
            </blockquote>
          </div>
        </div>
        <div id="image" className="containerImageProfs">
          <figure id="img_bloc" className="blocImageProfs">
            <img
              src="./images/oriane_web.jpg"
              data-src="./images/oriane_web.jpg"
              alt="Cours de danse Blanquefort"
              width="1276"
              height="687"
              className="image"
              onMouseOver={(e) => e.currentTarget.classList.add('imageHover')}
              onMouseOut={(e) => e.currentTarget.classList.remove('imageHover')}
            />
          </figure>
        </div>
      </div> */}
    </div>
  )
}

export default Professeurs
